import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import { cn } from '@/app/utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    size?: 'sm' | 'default';
    showTicks?: boolean; // 是否显示步长刻度点
    skipValues?: number[]; // 禁用值
  }
>(({ className, size = 'default', showTicks = false, skipValues = [], ...props }, ref) => {
  const min = props.min || 0;
  const max = props.max || 1;
  const value = props.value || [0];

  // SliderPrimitive.Thumb 有类似的计算，避免点超出 Range（所有最右侧的 left 值不是 100%，而是100% - dotWidth）
  function getThumbInBoundsOffset(index: number) {
    const dotWidth = 8;
    const leftOffset = 0;
    return -((min + index) / (max - min)) * dotWidth + leftOffset;
  }

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full cursor-pointer touch-none select-none items-center disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          'relative h-1 w-full grow rounded-2 bg-[var(--slider-track-color,#30343B)]',
          size === 'sm' && 'h-0.5',
        )}
      >
        <SliderPrimitive.Range className="absolute h-full rounded-2 bg-[var(--slider-range-color,#fff)]" />
        {showTicks &&
          new Array(max - min + 1).fill(0).map((_, index) => (
            <div
              key={`slider-tick-${index + 1}`}
              className={cn(
                '-top-0.5 absolute left-[var(--left)] size-2 rounded-full bg-[var(--slider-track-color,#30343B)]',
                min + index <= value[0] && 'bg-[var(--slider-range-color,#fff)]',
                skipValues.includes(min + index) && 'hidden',
              )}
              style={
                {
                  '--left': `calc(${(index / (max - min)) * 100}% ${getThumbInBoundsOffset(index) > 0 ? '+' : '-'} ${Math.abs(
                    getThumbInBoundsOffset(index),
                  )}px)`,
                } as React.CSSProperties
              }
            />
          ))}
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          'block size-3.5 rounded-full bg-[var(--slider-range-color,#fff)] transition-colors',
          size === 'sm' && 'size-1.5',
        )}
      />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
